import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {useSelector} from "react-redux";
import Chip from "@mui/material/Chip";

const useSales = () => {

    let navigate = useNavigate();

    const authState = useSelector((state) => state.authReducer);

    const actions = {
        add: false,
        edit: (id) => false,
        delete: false,
    };

    const renderStatusChip = (status) => {
        switch (status) {
            case 'pending':
                return <Chip size="small" color="warning" label="Pendiente"
                             variant="outlined"/>;
            case 'in_transit':
                return <Chip size="small" color="secondary" label="Preparando"
                             variant="outlined"/>;
            case 'paid':
                return <Chip size="small" color="success" label="Pagado"
                             variant="outlined"/>;
        }
    };

    return {
        actions,
        renderStatusChip
    }
};

export default useSales;
